module.exports = __webpack_public_path__ + "03_mustache_brown.bda8c299.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/03_mustache_brown.png
// module id = JUQX
// module chunks = 0